import classNames from 'classnames'
import { type FC } from 'react'

interface PiiRedactionBadgeProps {
  redacted: boolean
}

export const PiiRedactionBadge: FC<PiiRedactionBadgeProps> = ({ redacted }) => (
  <div
    className={classNames('d-flex py-1 px-2 justify-content-center align-items-center rounded-2 zocks-border-0.5', {
      'zocks-text-primary-dark zocks-bg-color-primary-light': redacted,
      'zocks-text-gray-600 zocks-bg-color-gray-200': !redacted,
    })}
  >
    {redacted ? 'Redacted' : 'Not redacted'}
  </div>
)
